module.exports = __webpack_public_path__ + "officialStatic/img/news18.6ad1b80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/news18.jpg
// module id = 6oum
// module chunks = 0